import { FC } from "react";
import { Flex } from "@smile2impress/components/relaunch";

import { AnimatedBurgerProps } from "./AnimatedBurger.types";

const LARGE_SIZE = 36;

export const AnimatedBurger: FC<AnimatedBurgerProps> = ({}) => {
    const Line = () => <Flex h="2px" bgColor="base.white" />;
    return (
        <Flex
            direction="column"
            justifyContent="space-between"
            py="9px"
            px="7px"
            h={`${LARGE_SIZE}px`}
            w={`${LARGE_SIZE}px`}
        >
            <Line />
            <Line />
            <Line />
        </Flex>
    );
};
